import { apiRequest } from './index';

export const fetchPhicRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/phics/' + id, {}, success, failure);
}

export const fetchPhicsRequest = ( selectedDate, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/phics?selectedDate=${selectedDate}`, {}, success, failure);
}

export const createPhicRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/phics',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const createPhicGroupRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/phics/group',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editPhicRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/phics/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deletePhicRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/phics/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}

export const getEffectiveDateList = ( success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/phics/effective-date/list',
        { method: 'GET' },
        success,
        failure
    )
}